import { constructInformationLigneTournee } from '@/services/logistique/tourneeModele/addInformationPatrimonialTourneeLigne';
import { getAffectationRegroupement } from '@/api/produit/produitFace';
import formatIsoDate from '@/services/general/formatIsoDate';
import messageInfo from '@/services/general/messageInformation';
import getAllTourneeLigne from '@/api/logistique/tourneeLigne/index';
import cloneDeep from 'lodash/cloneDeep';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

export async function getTourneeLigneFromFacePatri(facePatri, ordre, i18n) {
  const tourneeLigne = {
    ordre: ordre,
    faceId: facePatri.id,
    selected: false,
  };
  const reseauInformation = (await getAffectationRegroupement({
    dateVisu: formatIsoDate(new Date()),
    produitIds: [facePatri.produitId],
  })).data.result;
  constructInformationLigneTournee(facePatri, tourneeLigne, reseauInformation[facePatri.produitId]);
  messageInfo(i18n.t('addEditTourneeModele.info.facesAddSuccess'));
  return tourneeLigne;
}

export async function getTourneeLigneFromFacePatriListe(
  facesPatri, ordre, i18n, societeId, messages,
) {
  const reseauInformation = (await getAffectationRegroupement({
    dateVisu: formatIsoDate(new Date()),
    produitIds: facesPatri.map((face) => { return face.produitId; }),
  })).data.result;

  const tourneeLigne = [];
  let newOrdre = cloneDeep(ordre);

  const tourneeLigneWithFaceId = (
    await getAllTourneeLigne({
      query: {
        faceIds: facesPatri.map((f) => f.id), societeId: societeId,
      },
      limit: NO_PAGINATION,
    })
  ).data.result.items;
  const faces = facesPatri.filter((f) => !tourneeLigneWithFaceId.map(t => t.faceId).includes(f.id));
  faces.forEach((face) => {
    const faceOfTourneeLigne = {
      ordre: newOrdre,
      faceId: face.id,
      selected: false,
    };
    constructInformationLigneTournee(face, faceOfTourneeLigne, reseauInformation[face.produitId]);
    newOrdre += 10;
    tourneeLigne.push(faceOfTourneeLigne);
  });
  if (facesPatri.length !== tourneeLigne.length) {
    tourneeLigneWithFaceId.forEach(tourneeLigne => {
      const face = facesPatri.find(el => el.id === tourneeLigne.faceId);
      messages.push({
        codeFace: face.code,
        motif: i18n.t('addEditTourneeModele.facesNotAddListeAffichage.faceSurListeAffichage', { liste: tourneeLigne.tournee.libelle }),
      });
    });
  } else if (tourneeLigne.length > 1) {
    messageInfo(i18n.t('addEditTourneeModele.info.patrimoineAddSuccessMulti'));
  } else if (tourneeLigne.length === 1) {
    messageInfo(i18n.t('addEditTourneeModele.info.patrimoineAddSuccess'));
  }
  return tourneeLigne;
}
